import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const baseURL = "";

export default class HeaderService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getPersonalInfo(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/search`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
